import { render } from "./pdf_control.vue?vue&type=template&id=6a711bfa&scoped=true"
import script from "./pdf_control.vue?vue&type=script&lang=js"
export * from "./pdf_control.vue?vue&type=script&lang=js"

import "./pdf_control.vue?vue&type=style&index=0&id=6a711bfa&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Shoma\\Documents\\Manabibako\\src\\basic-package30\\app\\Elearning\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a711bfa"],['__file',"Scripts/components/control/pdf_control.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a711bfa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a711bfa', __exports__)) {
    api.reload('6a711bfa', __exports__)
  }
  
  module.hot.accept("./pdf_control.vue?vue&type=template&id=6a711bfa&scoped=true", () => {
    api.rerender('6a711bfa', render)
  })

}


export default __exports__